import React from "react";
import "../styles/loading.css";
function Loader() {
  return (
    <div className="loaderWrapper">
      <span className="loader"></span>
    </div>
  );
}

export default Loader;
